var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-navigation"},[(_vm.currentStep > 0)?_c('u-button',{attrs:{"type":"secondary"},on:{"click":function($event){return _vm.goToStep(-1)}}},[_vm._v(" Vorige ")]):_vm._e(),_c('u-button',{attrs:{"loading":_vm.loading},on:{"click":function($event){return _vm.goToStep(1)}}},[_vm._v(" Volgende ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }